export default {
    header: {
        text1: "Home",
        text2: "How to play",
        text3: "Market",
        text4: "Login",
    },
    home: {
        text1: "The world’s first blockchain fishing game",
        text2: "Fishing Earn & Have Fun",
        text3: "Play Now",
        text4: "Also available on",
        text5: "Apple Store",
        text6: "Google Play",
        text7: "Android Apk",
        text8: "Come soon~",
    },
};
